// ***************
// src/app/services/getsaveuserinfo.jsx
// autor: WdePaula / MVinfo 
// data: 19/7/24 | 20h23
// ***************

import { encrypt, decrypt } from "./cryptoUtils";

// Função para salvar dados no localStorage
export function saveUserInfo(nome, celular) {
    const userVars = {
        usernome: nome,
        userfone: celular
    };

    const encryptedUser = encrypt(userVars);
    localStorage.setItem('usuarioAnonimo', encryptedUser);
    // sessionStorage.setItem('usuarioAnonimo', encryptedUser);
}

// Função para recuperar dados do localStorage
export function getUserInfo() {
    const encryptedUser = localStorage.getItem('usuarioAnonimo');
    // const encryptedUser = sessionStorage.getItem('usuarioAnonimo');
    if (encryptedUser) {
        try {
            const decryptedUser = decrypt(encryptedUser);
            if (decryptedUser) {
                return {
                    nome: decryptedUser.usernome,
                    celular: decryptedUser.userfone
                };
            }
        } catch (error) {
            console.error('Erro ao descriptografar ou fazer o parse dos dados:', error);
        }
    }
    return {
        nome: '',
        celular: ''
    };
}
